import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useMemo } from 'react';
import ChestsIcon from '../../assets/images/chests/chest-with-treasure.png';
import StoreIco from '../../assets/images/utils/store.png';
import Upgrade from '../../assets/images/utils/upgrade.png';
import EarnIco from '../../assets/svg/utils/coins/coin-ltr.svg';
import Spin from '../../assets/images/utils/home.png';
import SpinActive from '../../assets/images/utils/home-active.png';
import Pages from '../../Router/pages';
import { useAppSelector } from '../../store';
import { MenuItemsT } from '../../types';
import { isActivePage } from '../utils/isActivePage';
import useThrottle from '../../hooks/useThrottle';

const MenuItems: MenuItemsT[] = [
  {
    label: 'Chests',
    link: '/chests',
    ico: <img src={ChestsIcon} alt="chests" className="w-[30px]" />,
    boxStyle: {
      transform: 'translate(-10px, -9px)',
    },
    titleStyle: {
      transform: 'translateY(5px)',
    },
  },

  {
    label: 'Earn',
    link: '/quests',
    ico: <img src={EarnIco} alt="earn-icon" className="w-[28px]" />,
    boxStyle: {
      transform: 'translate(-3px, -7px)',
    },
    titleStyle: {
      transform: 'translateY(3px)',
    },
  },
  {
    label: 'Spin',
    link: '/',
    ico: <img src={Spin} height={62} alt="spin" className="spin-menu-button ml-[1px] mt-[-12px] h-[62px]" />,
    activeIco: <img src={SpinActive} height={62} alt="spin" className="spin-menu-button ml-[1px] mt-[-12px] h-[62px]" />,
    disableBG: true,
    titleStyle: {
      transform: 'translateY(-15px)',
      background: 'none',
      color: '#fff',
      fontSize: '1rem',
    },
  },
  {
    label: 'Upgrade',
    link: '/upgrade',
    ico: <img src={Upgrade} alt="upgrade" className="w-[33px]" />,
    boxStyle: {
      transform: 'translate(3px, -6px)',
    },
    titleStyle: {
      transform: 'translate(2px, 6px)',
    },
  },
  {
    label: 'Store',
    link: '/store',
    ico: <img src={StoreIco} alt="store" className="w-[45px]" />,
    boxStyle: {
      transform: 'translate(7px, -7px)',
    },
    titleStyle: {
      transform: 'translate(1px, -4px)',
    },
  },
];

function Menu() {
  const navigate = useNavigate();
  const { activeGame, slotGameStatus } = useAppSelector(({ aviator }) => aviator);
  const { pathname } = useLocation();

  const isMenuHidden = activeGame === 'aviator';
  const isMenuDisabled = slotGameStatus === 'spinning';

  const handleNavigate = (path: string) => {
    navigate(path, {});
  };
  const throttle = useThrottle(handleNavigate, 700);
  const throttleFunc = useMemo(() => throttle, []);
  return (
    <div
      id="bottom_navigation_menu"
      className={`bg-menuBg bg-no-repeat bg-fullfull h-[53px] bg-contain fixed bottom-0 mx-auto flex justify-center w-full menu z-[1500] ${isMenuHidden ? 'hidden' : 'visible'}`}
    >
      <ul
        className="mx-auto rounded-10 flex justify-around p-1 mb-1 w-full mt-[-15px] pl-[18px] pr-[13px]"
        id="app-menu-list"
      >
        {MenuItems.map((menuItem) => {
          const routes: string[] = [];

          // if (menuItem.link !== '/') {
          routes.push(menuItem.link as string);
          // }

          if (menuItem.link === '/chests') {
            routes.push(Pages.chest());
          }

          const isActive = isActivePage(pathname, routes);

          return (
            <li
              className="rounded mt-0 w-full"
              key={menuItem.label}
              id={`menu-${menuItem.label}`}
              style={{
                ...menuItem?.boxStyle,
              }}
            >
              <Link
                to={menuItem.link as string}
                className={`
                  min-h-[50px]
                  h-full
                  cursor-pointer 
                  p-1 
                  flex flex-col items-center justify-center
                  rounded-8 
                  ${(isActive && !menuItem.disableBG) ? 'active-menu-item-custom' : ''}
                  ${isMenuDisabled ? 'pointer-events-none' : ''}
                `}
                onClick={(e) => {
                  e.preventDefault();
                  throttleFunc(menuItem.link as string);
                }}
              >
                {(isActive && menuItem.activeIco) ? menuItem.activeIco : menuItem.ico}
                <div
                  className="text-sm text-nowrap font-Bangers mt-[-8px] z-[1] px-1 leading-[15px] tracking-[0.08rem]"
                  style={{
                    background: 'linear-gradient(180deg, #6064FF 10%, #FFFFFF 69%)',
                    color: 'transparent',
                    backgroundClip: 'text',
                    ...menuItem.titleStyle,
                  }}
                >
                  {menuItem.label}
                </div>
              </Link>
            </li>
          );
        })}
      </ul>
    </div>
  );
}

export default Menu;
